import { App, app } from '../App';
import BaseScene from './BaseScene';

export default class PreloadScene extends BaseScene {
  protected loadTimer: number;
  protected minLoadTime: number;
  protected assetsLoaded: boolean;
  protected fontsLoaded: boolean;
  protected pastMinLoadTime: boolean;

  constructor(key: string) {
    super(key);

    this.loadTimer = 0;
    this.minLoadTime = 1000;
    this.assetsLoaded = false;
    this.fontsLoaded = app.AssetManager.AreFontsLoaded;
    this.pastMinLoadTime = false;

    if (!this.fontsLoaded) {
      app.on(App.events.FontsLoaded, () => {
        this.fontsLoaded = true;
        this.checkPreloadFinished();
      });
    }
  }

  public create() {
    super.create();

    this.assetsLoaded = true;
    this.checkPreloadFinished();
  }

  public update(time: number, delta: number): void {
    if (!this.pastMinLoadTime) this.loadTimer += delta;
    if (this.loadTimer >= this.minLoadTime && !this.pastMinLoadTime) {
      this.pastMinLoadTime = true;
      this.checkPreloadFinished();
    }
  }

  protected finish(): void {
    super.finish();
  }

  protected checkPreloadFinished() {
    if (this.assetsLoaded && this.fontsLoaded && this.pastMinLoadTime) {
      this.finish();
    }
  }
}
